import { Box, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { sxs } from '@utils/mui/sx';

const treePathSx: SxProps = {
    alignItems: 'center',
    color: 'grey.300',
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: 12,
};

interface ClickablePathProps {
    hitId: string;
    overrideContainerBoxSx?: SxProps;
    paths: JSX.Element[][];
}

const ClickablePath: FC<ClickablePathProps> = ({ hitId, overrideContainerBoxSx, paths }) => (
    <Box data-test-id="keywordPath" sx={sxs([{ my: 1.5 }, overrideContainerBoxSx || {}])}>
        {paths.length === 1 ? (
            <Typography sx={treePathSx}>{paths}</Typography>
        ) : (
            <Box component="ul" sx={{ m: 0, pl: 3 }}>
                {paths.map((path, index) => (
                    <Box key={`${hitId}_keywordPath_${index + 1}`} component="li" sx={{ mb: 1 }}>
                        <Typography sx={treePathSx}>{path}</Typography>
                    </Box>
                ))}
            </Box>
        )}
    </Box>
);

export default ClickablePath;
